// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompressedNftEvent } from './CompressedNftEvent';
import {
    CompressedNftEventFromJSON,
    CompressedNftEventFromJSONTyped,
    CompressedNftEventToJSON,
} from './CompressedNftEvent';
import type { TransactionEventNft } from './TransactionEventNft';
import {
    TransactionEventNftFromJSON,
    TransactionEventNftFromJSONTyped,
    TransactionEventNftToJSON,
} from './TransactionEventNft';
import type { TransactionEventSwap } from './TransactionEventSwap';
import {
    TransactionEventSwapFromJSON,
    TransactionEventSwapFromJSONTyped,
    TransactionEventSwapToJSON,
} from './TransactionEventSwap';

/**
 * 
 * @export
 * @interface TransactionEvent
 */
export interface TransactionEvent {
    /**
     * 
     * @type {TransactionEventNft}
     * @memberof TransactionEvent
     */
    nft: TransactionEventNft | null;
    /**
     * 
     * @type {TransactionEventSwap}
     * @memberof TransactionEvent
     */
    swap: TransactionEventSwap | null;
    /**
     * 
     * @type {Array<CompressedNftEvent>}
     * @memberof TransactionEvent
     */
    compressed: Array<CompressedNftEvent> | null;
}

/**
 * Check if a given object implements the TransactionEvent interface.
 */
export function instanceOfTransactionEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "nft" in value;
    isInstance = isInstance && "swap" in value;
    isInstance = isInstance && "compressed" in value;

    return isInstance;
}

export function TransactionEventFromJSON(json: any): TransactionEvent {
    return TransactionEventFromJSONTyped(json, false);
}

export function TransactionEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nft': TransactionEventNftFromJSON(json['nft']),
        'swap': TransactionEventSwapFromJSON(json['swap']),
        'compressed': (json['compressed'] === null ? null : (json['compressed'] as Array<any>).map(CompressedNftEventFromJSON)),
    };
}

export function TransactionEventToJSON(value?: TransactionEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nft': TransactionEventNftToJSON(value.nft),
        'swap': TransactionEventSwapToJSON(value.swap),
        'compressed': (value.compressed === null ? null : (value.compressed as Array<any>).map(CompressedNftEventToJSON)),
    };
}

